@if (totalPages() > 1) {
<ul class="pagination">
	@if (page() != 1) {
	<li>
		<a (click)="pageClicked(prevPage())" class="jump">
			<i class="ico ico-chevron-left"></i>
		</a>
	</li>
	} @for (p of pagesRange(); track p) {
	<li [ngClass]="{ currentPage: p === page() }">
		<a (click)="pageClicked(p)" class="pageLink">{{ p }}</a>
	</li>
	} @if (totalPages() > page()) {
	<li>
		<a (click)="pageClicked(nextPage())" class="jump">
			<i class="ico ico-chevron-right"></i>
		</a>
	</li>
	}
</ul>
}
